export const setLoading = state => () => {
  return {
    ...state,
    client: {
      ...state.client,
      requestsInProgress: ++state.client.requestsInProgress,
    },
  };
};

export const onGetClient = state => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    client: {
      ...state.client,
      requestsInProgress: ++state.client.requestsInProgress,
    },
  };
};
export const onGetClientSuccess = state => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    client: {
      ...state.client,
      requestsInProgress: --state.client.requestsInProgress,
      current: payload,
    },
  };
};
export const onGetClientError = state => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    client: {
      ...state.client,
      current: [],
      requestsInProgress: --state.client.requestsInProgress,
    },
  };
};

export const onGetClientsSuccess = state => ({ payload }: Object) => {
  return {
    ...state,
    client: {
      ...state.client,
      requestsInProgress: --state.client.requestsInProgress,
      list: payload,
    },
  };
};

export const onGetClientsError = state => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    client: {
      ...state.client,
      requestsInProgress: --state.client.requestsInProgress,
      list: {
        ...state.client.list,
        content: [],
      },
    },
  };
};

export const onSetClientsSort = state => ({ payload }) => {
  return {
    ...state,
    client: {
      ...state.client,
      requestsInProgress: ++state.client.requestsInProgress,
      list: {
        ...state.client.list,
        pagination: {
          ...state.client.list.pagination,
          sort: {
            ...state.client.list.pagination.sort,
            orders: [
              { property: payload.sort.id, direction: payload.sort.direction.toUpperCase() },
            ],
          },
        },
      },
    },
  };
};

export const onUpdateClientDetails = state => ({ payload }) => {
  return {
    ...state,
    error: null,
    success: null,
    client: {
      ...state.client,
      requestsInProgress: ++state.client.requestsInProgress,
    },
  };
};

export const onUpdateClientDetailsSuccess = state => ({ payload }) => {
  return {
    ...state,
    error: null,
    client: {
      ...state.client,
      requestsInProgress: --state.client.requestsInProgress,
      list: {
        ...state.client.list,
        // content: payload
      },
      addClientModal: {
        client: null,
      },
    },
  };
};
export const onUpdateClientDetailsError = state => ({ payload }: Object) => {
  return {
    ...state,
    success: null,
    error: payload,
  };
};

export const onGetClientsCsv = state => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    client: {
      ...state.client,
      requestsInProgress: ++state.client.requestsInProgress,
    },
  };
};

export const onGetClientsCsvSuccess = state => ({ payload }: Object) => {
  return {
    ...state,
    error: null,
    client: {
      ...state.client,
      requestsInProgress: --state.client.requestsInProgress,
    },
  };
};

export const onGetClientsCsvError = state => ({ payload }: Object) => {
  return {
    ...state,
    error: payload,
    client: {
      ...state.client,
      requestsInProgress: --state.client.requestsInProgress,
    },
  };
};

export const onSetClientsSchema = state => ({ payload }) => {
  return {
    ...state,
    client: {
      ...state.client,
      schema: payload,
      requestsInProgress: --state.client.requestsInProgress,
    },
  };
};

// MODALS

export const onToggleAddClientModal = state => ({ payload }: Object) => {
  return {
    ...state,
    client: {
      ...state.client,
      modals: {
        ...state.modals,
        showAddModal: payload ? payload : !state.client.modals.showAddModal,
      },
    },
  };
};
export const onToggleEditClientModal = state => ({ payload }: Object) => {
  return {
    ...state,
    client: {
      ...state.client,
      modals: {
        ...state.client.modals,
        showEditModal: payload,
      },
    },
  };
};
export const onAddClientDetails = state => ({ payload }: Object) => {
  ++state.client.requestsInProgress;
  return state;
};
export const onAddClientDetailsSuccess = state => ({ payload }: Object) => {
  state.client.error = payload;
  state.client.requestsInProgress =
    state.client.requestsInProgress > 0 ? --state.client.requestsInProgress : 0;
  return state;
};
export const onAddClientDetailsError = state => ({ payload }: Object) => {
  state.client.requestsInProgress =
    state.client.requestsInProgress > 0 ? --state.client.requestsInProgress : 0;
  return state;
};

export const onToggleAddAdminAccountModal = state => ({ payload }: Object) => {
  return {
    ...state,
    client: {
      ...state.client,
      modals: {
        ...state.client.modals,
        showAddAdminAccountsModal: payload,
      },
    },
  };
};
export const onToggleAdditionalOptionsModal = state => ({ payload }: Object) => {
  return {
    ...state,
    client: {
      ...state.client,
      modals: {
        ...state.client.modals,
        showAdditionalOptionsModal: payload,
      },
    },
  };
};
export const onToggleSelfServiceModal = state => ({ payload }: Object) => {
  return {
    ...state,
    client: {
      ...state.client,
      modals: {
        ...state.client.modals,
        showSelfServiceModal: payload,
      },
    },
  };
};
export const onToggleMainOptionsModal = state => ({ payload }: Object) => {
  return {
    ...state,
    client: {
      ...state.client,
      modals: {
        ...state.client.modals,
        showMainOptionsModal: payload,
      },
    },
  };
};
